
import { mapState } from "vuex";

import VueLazyHydrate from "vue-lazy-hydration";
import { gtmEventMixin, campaignMixin } from "~/mixins";

export default {
  components: { VueLazyHydrate },

  mixins: [gtmEventMixin, campaignMixin],

  inject: { campaign: { default: null } },

  props: {
    styles: { type: Object, default: () => {} },
    product: { type: Object, required: true },
    images: { type: Array, default: () => [] },
    buttonContent: { type: String, default: "" },
    selectedVariant: { type: Object, default: () => {} },
    variantImageSrc: { type: String, required: true },
  },

  data: () => ({ isScrolled: false, showStickyHeader: false }),

  computed: {
    ...mapState(["siteConfig"]),
    addToCartProps() {
      return {
        selectedVariant: this.selectedVariant,
        product: this.product,
        styles: this.styles,
        buttonContent: this.buttonContent,
      };
    },
    price() {
      return this.selectedVariant.price;
    },
    compareAtPrice() {
      return this.selectedVariant?.compareAtPrice;
    },
  },

  methods: {
    emitGTMEvent() {
      const dataSet = {
        ...this.selectedVariant,
        name: this.product.title,
        collections: this.product.collections,
        brand: this.product.brand_list,
        available: this.selectedVariant?.availableForSale,
        type: this.productType,
      };
      this.gtmProductDetailView(dataSet);
    },
    emitGTMAddToCartEvent() {
      const dataSet = {
        ...this.selectedVariant,
        name: this.product.title,
        collections: this.product.collections,
        brand: this.product.brand_list,
        available: this.selectedVariant?.availableForSale,
        type: this.product.productType,
      };
      this.gtmAddToCart(dataSet);
    },
    catchAddToCartScroll(event, el) {
      this.showStickyHeader = window.pageYOffset > el.offsetTop;
    },
  },
};
